import { sideMenuSlice } from './sidemenu.reducer';

export const { SET_ACTIVE_PATH } = sideMenuSlice.actions;
